
import { generateRandomEntry } from '../utils/chat.utils'
import Card from 'vux/src/components/card/index.vue'

export default {
  name: 'vux',
  data () {
    return {
      messages: [],
      header: {title: 'This is a header'},
      currentMessage: ''
    }
  },
  methods: {
    addMaliciousEntry: function (malicious) {
      const randomMessage = generateRandomEntry(malicious)
      this.messages.push(randomMessage)
      this.currentMessage = randomMessage
    }
  },
  computed: {
    vuxMessages: function () {
      return this.messages.map((message) => ({title: message.text}))
    }
  },
  components: {Card}
}



// WEBPACK FOOTER //
// ./src/pages/vux.vue